module.exports = __webpack_public_path__ + "static/img/bg4-hover.91ed0b9b.png";